import * as React from "react";
const ArrowBackSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 11"
    width={props.width || 12}
    height={props.width - 1 || 11}
    fill="none"
    preserveAspectRatio="xMinYMin meet"
    {...props}
  >
    <path
      fill={props.fill ?? "#9DA2A6"}
      fillOpacity={0.6}
      fillRule="evenodd"
      d="M10.388 5.062H2.94l3.253-3.254a.672.672 0 0 0 0-.946.664.664 0 0 0-.94 0L.861 5.255c-.26.26-.26.68 0 .94l4.393 4.393a.664.664 0 1 0 .94-.94L2.941 6.395h7.447c.366 0 .666-.3.666-.667 0-.366-.3-.666-.666-.666Z"
      clipRule="evenodd"
    />
  </svg>
);
export default ArrowBackSVG;
